<template>
  <div class="cell-title">
    <div class="left">{{ title }}</div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CellTitle',
  props: {
    title: String,
    sendData: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
		
    }
  },
  methods: {
    
  }
}
</script>

<style lang="less" scoped>
.cell-title {
  display: flex;
  justify-content: space-between;
  position: relative;

  .left {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    padding-bottom: 20px;

    p {
      font-size: 18px;
      font-weight: 500;
      color: #222222;
    }

    .right {
      font-size: 12px;
    }
  }
}
</style>